import { SearchService } from './../../../services/search.service';
import { AttachmentScopesEnum, AttachmentTypeEnum } from './../../../models/enums/Attachment/AttachmentEnum';
import { LoadingService } from './../../../services/loading.service';
import { Customer } from './../../../models/Customer';
import { AuthService } from './../../../services/auth.service';
import { element } from 'protractor';
import { IconService } from './../../../services/icon.service';
import { ViewBookingModel } from 'src/app/models/Booking/ViewBookingModel';
import { BookingService } from 'src/app/services/booking.service';
import { Component, EventEmitter, Output, OnInit, OnDestroy } from '@angular/core';
import { AdditionalServiceType, AgencyReturnLocationTypes, ModeType, PredefinedAdditionalServiceEnum, RentalDeliveryTypeEnum } from 'src/app/models/enums/BookingEnums';
import { LstAdditionalServiceReservationCase, LstVehicleReservationCaseNonWorkingHoursChargeModel } from 'src/app/models/VehicleReservationCaseDetailsModel';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { CrossBorderModel } from 'src/app/models/Booking/CrossBorderModel';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { GoogleMapPinComponent } from '../google-map-pin/google-map-pin.component';
import { Vehicle } from 'src/app/models/Vehicle';
import { ViewBookingBaseComponent } from 'src/app/views/booking/view-booking-base/view-booking-base.component'
import { OneWayRentalModel } from 'src/app/models/Booking/OneWayRentalModel';
import { UpdateConfirmedAdditionalServicePram } from 'src/app/models/Booking/UpdateConfirmedAdditionalServicePram';
import { VehicleReservationCaseResult } from 'src/app/models/Booking/VehicleReservationCaseResult';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { AttachmentService } from 'src/app/services/attachment.service';
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Directive, HostListener } from '@angular/core';


@Component({
  selector: 'add-remove-extras-modal',
  templateUrl: './add-remove-extras-modal.component.html',
  styleUrls: ['./add-remove-extras-modal.component.scss']
})
export class AddRemoveExtrasModalComponent extends ViewBookingBaseComponent implements OnInit, OnDestroy {


  submitted = false;
  faTimesCircle = faTimesCircle;
  viewBooking: ViewBookingModel;
  form: FormGroup;
  bookingData;
  formControlPrefix = 's_';
  formControlTotalPostfix = '_total';
  formControlTogglePostfix = '_toggle';
  selectedSkills;
  driverSkills;
  borders: FormArray;
  selectedBorders: CrossBorderModel[] = [];
  crossBorders: CrossBorderModel[];
  vehicle: Vehicle;
  //Flag for One Way Rental : PickUpLocation and DropUp Location
  pickupLocationFlag: boolean = true;
  returnLocationFlag: boolean = true;
  showExistBorder = false;

  oneWayRentalLocations: OneWayRentalModel[] = [];
  selectedOneWayRental: OneWayRentalModel;


  drivers;

  needPayment: boolean = false;

  //Validation Helper Variables
  rentalDeliveryErrors: boolean = false;
  flag = false;
  vehicleReservationCaseResult: VehicleReservationCaseResult;
  requiredPayment: any;
  @Output() onCancel = new EventEmitter();
  objPayment: any;
  viewBookingData: BehaviorSubject<ViewBookingModel>;
  oneWayRentalFlag: boolean;
  subscriptions: Subscription[] = [];
  currency: string;

  constructor(
    //private dialogRef: MatDialogRef<AddRemoveExtrasModalComponent>
    private bookingService: BookingService
    , private domSanitizer: DomSanitizer
    , private matIconRegistry: MatIconRegistry
    , private _formBuilder: FormBuilder
    , private dialog: MatDialog
    , private authService: AuthService
    ,private searchService:SearchService
    , private loadingService: LoadingService
    , private iconService: IconService
    , private router: Router
    , private attachmentService: AttachmentService
    , private notifications: NotificationsService
    , private translate: TranslateService
  ) {
    super(iconService, domSanitizer, matIconRegistry);
    this.currency = searchService.getCurrency();
    this.matIconRegistry.addSvgIcon(
      "steeringWheel",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.steeringWheel)
    );
    this.matIconRegistry.addSvgIcon(
      "childSeats",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.childSeats)
    );
    this.matIconRegistry.addSvgIcon(
      "GPSNavigation",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.GPSNavigation)
    );
    this.matIconRegistry.addSvgIcon(
      "additionalService",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.additionalService)
    );


  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })
  }



  ngOnInit() {
    this.viewBookingData = new BehaviorSubject(null);
    this.form = this._formBuilder.group({

    });


    this.subscriptions.push(this.bookingService.vehicle.subscribe(res => {

      this.subscriptions.push(this.bookingService.vehicleReservationCaseResult.subscribe(data => {
        if (data != null) {
          this.vehicleReservationCaseResult = data;
          //Deep Copy of the response
          let copiedItem = {};
          copiedItem = Object.assign({}, copiedItem, data);
          let _viewBooking = this.bookingService.reservationCaseToViewBookingModel(copiedItem as VehicleReservationCaseResult);
          this.viewBooking = _viewBooking;
          let res = _viewBooking;

          if (res != null) {
            setTimeout(() => {
              this.loadingService.updateLoadingState(true);
            });

            this.bookingService.getReservationCaseAdditionalService({ caseID: res.caseID })
              .subscribe(lst => {


                if (lst != null) {
                  /*  res.lstAdditionalServiceReservationCase.forEach(element => {

                     //this.loadAdditionalServiceData(element, res.agencyID);
                     //For Now -For the release
                     //Todo:
                     this.loadAdditionalServiceData(element, res.agencyID);
                     this.updateFormWithSelectedServices(element);



                     this.bookingData = new BehaviorSubject(this.form);

                   }); */

                  lst.forEach(element => {

                    this.loadAdditionalServiceData(element, res.agencyID);
                    this.updateFormWithSelectedServices(element, res.agencyID);

                    this.bookingData = new BehaviorSubject(this.form);

                  });

                  let _form = this.form;
                  this.form = null;
                  this.form = _form;

                  /*                 if (this.viewBooking.lstAdditionalServiceReservationCase != null) {
                                    this.viewBooking.lstAdditionalServiceReservationCase.push.apply(this.viewBooking.lstAdditionalServiceReservationCase, lst);

                                  }
                                  else {
                                    this.viewBooking.lstAdditionalServiceReservationCase = lst;
                                  } */
                  this.viewBooking.lstAdditionalServiceReservationCase = lst;



                  this.viewBookingData.next(this.viewBooking);

                  this.flag = true;
                }
                this.loadingService.updateLoadingState(false);
              });


          }

        }
      }))
      this.vehicle = res;
    }));






  }

  get attachmentTypeEnum() {
    return AttachmentTypeEnum;
  }
  get attachmentScopesEnum() {
    return AttachmentScopesEnum;
  }

  public get predefinedAdditionalServiceEnum(): typeof PredefinedAdditionalServiceEnum {
    return PredefinedAdditionalServiceEnum;
  }
  public get additionalServiceType(): typeof AdditionalServiceType {
    return AdditionalServiceType;
  }
  get lstAdditionalServiceReservationCaseTypeService(): LstAdditionalServiceReservationCase[] {
    if (this.flag && this.viewBooking != null && this.viewBooking.lstAdditionalServiceReservationCase != null) {
      return this.viewBooking.lstAdditionalServiceReservationCase.filter(a => a.additionalServiceTypeID == AdditionalServiceType.Service);
    }
    else {
      return [];
    }

  }

  get lstAdditionalServiceReservationCaseTypeCharge(): LstAdditionalServiceReservationCase[] {
    if (this.flag && this.viewBooking != null && this.viewBooking.lstAdditionalServiceReservationCase != null) {
      return this.viewBooking.lstAdditionalServiceReservationCase.filter(a => a.additionalServiceTypeID == AdditionalServiceType.Charge);;
    }
    else {
      return [];
    }

  }


  //Get the selected VehicleReservationCaseDetailsModel and Iterate it
  //Build the form based on the predefinedAdditionalServiceID and what it have (DropDown, List of values ..etc)
  //Bind the value to the control
  updateFormWithSelectedServices(element: LstAdditionalServiceReservationCase, agencyID) {


    if (element.isMandatory) {
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl({ value: true, disabled: true }))
    }
    else if (element.isSelectedByDefault) {
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl({ value: true }))
    }
    else {
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false))
    }

    //Todo: move to switch case rather than if else, (built withiin testing )
    if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery) {


      //IF Additional Service not selected and dont have a value , then init form with default value
      if (element.lstVehicleReservationCaseAdditionalServicesRentalDeliveryModel == null) {
        this.updateFormDynamically(element,agencyID);
        return;
      }

      let rentalDeliveryList = element.lstVehicleReservationCaseAdditionalServicesRentalDeliveryModel;
      let pickUpObj = this.viewBooking.isPickupAddress ? rentalDeliveryList.filter(o => o.rentalDeliveryTypeID == RentalDeliveryTypeEnum.Delivery)[0] : {};
      let returnObj = this.viewBooking.isReturnAddress ? rentalDeliveryList.filter(o => o.rentalDeliveryTypeID == RentalDeliveryTypeEnum.Receive)[0] : {};
      //IF The rental delivery not selected then update the form with default.


      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true))
      this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue(true);
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: false }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + "_RentalDeliveryFirstValidation", new FormControl(null));


      if (this.viewBooking.isPickupAddress) {
        //delete pickUpObj['rentalDeliveryTypeID'];
        pickUpObj['address'] = this.viewBooking.pickupAddress;
      }
      if (this.viewBooking.isReturnAddress) {
        //delete returnObj['rentalDeliveryTypeID'];
        returnObj['address'] = this.viewBooking.returnAddress;
      }


      this.form.addControl(this.formControlPrefix + element.additionalServiceID,
        new FormGroup({
          PickUpToggle: new FormControl({ value: this.viewBooking.isPickupAddress, disabled: false }),
          PickUpLocationName: this.viewBooking.isPickupAddress ? new FormControl({ value: this.viewBooking.pickupAddress, disabled: false }) : new FormControl({ value: '', disabled: false }),
          PickUpLocation: new FormControl(pickUpObj),
          ReturnToggle: new FormControl({ value: this.viewBooking.isReturnAddress, disabled: false }),
          ReturnLocationName: this.viewBooking.isReturnAddress ? new FormControl({ value: this.viewBooking.returnAddress, disabled: false }) : new FormControl({ value: '', disabled: false }),
          ReturnLocation: new FormControl(returnObj),
        }),
      )
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.CrossingBoarders) {

      //IF Additional Service not selected and dont have a value , then init form with default value
      if (element.lstCrossBorderModel == null) {
        this.updateFormDynamically(element,agencyID);
        return;
      }
      this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue(true);
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: true }));



      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: false }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + '_Borders', new FormArray([]));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: {}, disabled: false }));


      //Set Selected Border value
      //This to bind the selected borders to the Form
      //In the Add Booking the methodology was
      //To add the Selected borders in an Array of FormGroup under "BorderObj" property

      //Check if crossBorder that coming from API have values and get the object from it not from The Current LstAdditionalServiceReservationCase
      //Reason for this that the Crossing Border in View is differnt incase of update




      this.handleCrossingBorderData(element, agencyID);


    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.AdditionalDrivers) {
      //IF Additional Service not selected and dont have a value , then init form with default value
      if (element.totalQuantityUsedForCase == null || element.totalQuantityUsedForCase == 0) {
        this.updateFormDynamically(element,agencyID);
        return;
      }
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true))
      this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue(true);
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: false }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: element.totalQuantityUsedForCase, disabled: false }))
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService) {


      //IF Additional Service not selected and dont have a value , then init form with default value
      if (this.viewBooking.oneWayRentalModel == null || this.viewBooking.agencyID == this.viewBooking.oneWayRentalModel.returnAgencyID) {
        this.updateFormDynamically(element,agencyID);
        return;
      }

      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true))
      this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue(true);
      this.oneWayRentalFlag = true;
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl(0));
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: null, disabled: true }))
      let oneWayRental = this.viewBooking.oneWayRentalModel;
      oneWayRental.charge = element.unitPrice;
      oneWayRental.isTaxsable = element.isTaxable;
      this.selectedOneWayRental = oneWayRental;
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: oneWayRental, disabled: false }))
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.Drivers) {

      //IF Additional Service not selected and dont have a value , then init form with default value
      if (element.selectedSkillIds == null) {
        this.updateFormDynamically(element,agencyID);
        return;
      }

      this.driverSkills = element.agencyDriverBaseRatesSkills;
      const _selectedSkills = [];
      element.agencyDriverBaseRatesSkills.forEach((skill, index) => {
        if (this.viewBooking.selectedSkillIds.includes(skill.driverSkillID + '')) {
          _selectedSkills.push(element.agencyDriverBaseRatesSkills[index]);
        }
      })
      //let _selectedSkills = element.agencyDriverBaseRatesSkills.filter(o => this.viewBooking.selectedSkillIds.includes(o.driverSkillID + ""));
      this.selectedSkills = _selectedSkills;
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true));
      this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue(true);
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: false }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl(_selectedSkills))
      this.form.controls[this.formControlPrefix + element.additionalServiceID].setValue(this.selectedSkills);
    }
    else {
      //IF Additional Service not selected and dont have a value , then init form with default value
      if (element.totalQuantityUsedForCase == null || element.totalQuantityUsedForCase == 0) {
        this.updateFormDynamically(element,agencyID);
        return;
      }
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(true))
      this.form.controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix].setValue(true);
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: false }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: element.totalQuantityUsedForCase, disabled: false }))
    }



  }
  handleCrossingBorderData(element: LstAdditionalServiceReservationCase, agencyID: any) {

    let crossBorders = element.lstCrossBorderModel;
    let crossBorderIds = null;
    if (crossBorders != null) {
      crossBorderIds = crossBorders.map(o => o.agencyCrossedBorderID).join();
    }

    this.bookingService.getCrossBorders(agencyID, ModeType.Edit, crossBorderIds)
      .subscribe(res => {

        this.crossBorders = res;
        if (this.crossBorders != null) {
          this.crossBorders.forEach(border => {
            var selectedBorder=null;
            if(element.lstCrossBorderModel!=null){
              selectedBorder = element.lstCrossBorderModel.filter(a => a.agencyCrossedBorderID == border.agencyCrossedBorderID)[0];
            }


            if (selectedBorder != null) {
              let crossBorder: CrossBorderModel = {
                agencyCrossedBorderID: selectedBorder.agencyCrossedBorderID,
                charge: selectedBorder.charge,
                borderPortName: selectedBorder.borderPortName,
                increase: selectedBorder.increase,
                isNewInsurence: selectedBorder.isNewInsurence,
                countryBorderPortsID: selectedBorder.countyborderportId,
                isPermitRequired: selectedBorder.isPermitRequired
              }

              this.loadCrossingBorder(element, crossBorder);

            }
            // if (element.lstCrossBorderModel.map(a => a.agencyCrossedBorderID).includes(border.agencyCrossedBorderID)) {
            //   let crossBorder: CrossBorderModel = {
            //     agencyCrossedBorderID: border.agencyCrossedBorderID,
            //     charge: border.charge,
            //     borderPortName: border.borderPortName,
            //     increase: border.increase,
            //     isNewInsurence: border.isNewInsurence,
            //     countryBorderPortsID: border.countryBorderPortsID,
            //     isPermitRequired: border.isPermitRequired
            //   }
            //   /*    if(border.isNewInsurence){
            //        crossBorder.charge+=border.increase;
            //      } */
            //   this.loadCrossingBorder(element, crossBorder);
            // }
          })
        }
        else {
          element.lstCrossBorderModel.forEach(obj => {
            let crossBorder: CrossBorderModel = {
              agencyCrossedBorderID: obj.agencyCrossedBorderID,
              //Important
              //Todo:
              charge: obj.charge,
              borderPortName: obj.borderPortName,
              increase: obj.increase,
              isNewInsurence: obj.isNewInsurence,
              countryBorderPortsID: obj.countyborderportId,
              isPermitRequired: obj.isPermitRequired
            }
            /*  if(obj.isNewInsurence){
               crossBorder.charge+=obj.increase;
             } */
            this.loadCrossingBorder(element, crossBorder);

          });
        }
      });

  }

  //Get the VehicleReservationCaseDetailsModel and Iterate it
  //Build the form based on the predefinedAdditionalServiceID and what it have (DropDown, List of values ..etc)
  //The default case is only number or toggle without number
  updateFormDynamically(element: LstAdditionalServiceReservationCase,agencyID) {

    let isDisabled = true;
    if (element.isSelectedByDefault || element.isMandatory) {
      isDisabled = false;
    }

    if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery) {
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: isDisabled }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + "_RentalDeliveryFirstValidation", new FormControl(null));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID,
        new FormGroup({
          PickUpToggle: new FormControl({ value: false, disabled: isDisabled }),
          PickUpLocationName: new FormControl({ value: '', disabled: isDisabled }),
          PickUpLocation: new FormControl(null),
          ReturnToggle: new FormControl({ value: false, disabled: isDisabled }),
          ReturnLocationName: new FormControl({ value: '', disabled: isDisabled }),
          ReturnLocation: new FormControl(null),
        }),
      )
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.CrossingBoarders) {
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: isDisabled }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + '_Borders', new FormArray([]));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: {}, disabled: isDisabled }))
      this.handleCrossingBorderData(element, agencyID);
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.AdditionalDrivers) {
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: isDisabled }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: 1, disabled: isDisabled }))
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService) {
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl(0));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: null, disabled: isDisabled }))
    }
    else if (element.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.Drivers) {
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: isDisabled }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: [], disabled: isDisabled }))
    }
    else {
      //this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix, new FormControl(false))
      this.form.addControl(this.formControlPrefix + element.additionalServiceID + this.formControlTotalPostfix, new FormControl({ value: 0, disabled: isDisabled }));
      this.form.addControl(this.formControlPrefix + element.additionalServiceID, new FormControl({ value: 1, disabled: isDisabled }))

    }
  }

  //Load the Data for the additional Service controls
  loadAdditionalServiceData(element: LstAdditionalServiceReservationCase, agencyID) {

    switch (element.predefinedAdditionalServiceID) {
      case PredefinedAdditionalServiceEnum.OneWayRentalService:
        this.bookingService.getOneWayRentalLocaions(this.viewBooking.agencyID, this.viewBooking.oneWayRentalModel.returnAgencyID, ModeType.Edit, element.isTaxable, this.vehicle.classID, this.vehicle.makeID, this.vehicle.modelID, this.vehicle.year, this.vehicle.vehicleID, false)
          .subscribe(res => {

            this.selectedOneWayRental = res.filter(o => o.returnAgencyID == this.viewBooking.oneWayRentalModel.returnAgencyID)[0];
            this.oneWayRentalLocations = res;
          this.oneWayRentalFlag=true;
          });
        break;
      case PredefinedAdditionalServiceEnum.CrossingBoarders:


        break;
      case PredefinedAdditionalServiceEnum.Drivers:

        this.driverSkills = element.agencyDriverBaseRatesSkills;
        /* this.bookingService.getDriverSkills()
          .subscribe(res => {
            this.driverSkills = res;
          }); */
        break;
    }
  }




  //Handle toggle for the controls dynamically
  changeDisable(additionalService: LstAdditionalServiceReservationCase) {


    //Remove the NonWorkingHours Object if exist
    // if (additionalService.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService) {
    //   let controlName = this.formControlPrefix + additionalService.additionalServiceID;
    //   let controlNameToggle = controlName + '_toggle';
    //   if (!this.form.controls[controlNameToggle].value) {
    //     let detailsModel = this.viewBooking;
    //     let dropOffAndOneWayRental = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.isDropOffAndOneWayRental)[0];
    //     if (dropOffAndOneWayRental != null) {
    //       let index = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.indexOf(dropOffAndOneWayRental, 0);
    //       if (index > -1) {
    //         detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.splice(index, 1);

    //       }
    //     }
    //     detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(item => {
    //       item.isActive = true;
    //     })
    //     //this.form.controls[controlName].setValue(null);
    //     this.selectedOneWayRental=null;
    //     this.loadAdditionalServiceData(additionalService,this.vehicleReservationCaseResult.agencyID);

    //     this.viewBookingData.next(detailsModel);

    //   }


    // }


    //If its rental delivery (Pickup location or DropUp or both)
    if (additionalService.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery) {

      let controlName = 's_' + additionalService.additionalServiceID;
      let controlNameToggle = controlName + '_toggle';
      let formGroup = this.form.controls[controlName] as FormGroup;
      //If the toggle enabled then enable the checkbox inside it "only"
      if (this.form.controls[controlNameToggle].value) {


        Object.keys(formGroup.controls).forEach(key => {
          //if (key.includes('Toggle')) {
          formGroup.controls[key].enable();
          //}

        });
        this.addValidatorsToForm(additionalService);


      }
      //Else disable the checkboxes
      else {
        Object.keys(formGroup.controls).forEach(key => {
          //if (key.includes('Toggle')) {
          formGroup.controls[key].disable();
          formGroup.controls[key].clearAsyncValidators();
          formGroup.controls[key].updateValueAndValidity();
          //}

        });
        //let rentalDeliveryFirstValidation = 's_' + additionalService.additionalServiceID + "_RentalDeliveryFirstValidation";

        //this.form.controls[rentalDeliveryFirstValidation].clearValidators();

        let rentalDeliveryFirstValidation = 's_' + additionalService.additionalServiceID + "_RentalDeliveryFirstValidation";

        this.form.get(rentalDeliveryFirstValidation).clearValidators();
        this.form.get(rentalDeliveryFirstValidation).updateValueAndValidity();
        this.clearValidators(controlName, additionalService);
      }

    }
    else {

      //If Toggled enable the control else disable it
      //Here we have one control
      let controlName = 's_' + additionalService.additionalServiceID;
      let controlNameToggle = controlName + '_toggle';
      if (this.form.controls[controlNameToggle].value) {
        this.form.controls[controlName].enable();
        this.addValidatorsToForm(additionalService)
        //this.form.get(controlName).setValidators(Validators.required);
        //this.form.controls[controlName].setValidators(Validators.required);
        //If one way rental service
        if (additionalService.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService) {
          //this code needed to solve a bug in mat-select when resiting its value
          //Start
          this.selectedOneWayRental = null;
          this.form.removeControl(controlName);
          let temp = this.oneWayRentalLocations.slice();
          this.oneWayRentalLocations = [];
          this.oneWayRentalLocations = temp;
          this.form.addControl(controlName, new FormControl({ value: null }));
          this.oneWayRentalFlag = true;
          //End
        }
      }
      else {
        this.form.controls[controlName].disable();
        this.clearValidators(controlName, additionalService);
        //this.form.controls[controlName].clearValidators();


        //Remove the NonWorkingHours Object if exist
        if (additionalService.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.OneWayRentalService) {





          //this code needed to solve a bug in mat-select when resiting its value
          //Start
          this.form.removeControl(controlName);
          let temp = this.oneWayRentalLocations.slice();
          this.oneWayRentalLocations = [];
          this.oneWayRentalLocations = temp;
          this.form.addControl(controlName, new FormControl({ value: null }));
          this.selectedOneWayRental = null;
          this.oneWayRentalFlag = false;
          //End


          let detailsModel = this.viewBooking;
          if (detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.length > 0) {

            let dropOffAndOneWayRental = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.isDropOffAndOneWayRental)[0];
            if (dropOffAndOneWayRental != null) {
              let index = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.indexOf(dropOffAndOneWayRental, 0);
              if (index > -1) {
                detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.splice(index, 1);

              }
            }

            if (this.viewBooking.dropOffLocationID != this.viewBooking.agencyID) {
              let dropOffAndOneWayRental = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => (a.isActive == null || a.isActive) && a.nonWorkingHoursChargeTypeID == 2)[0];
              let index = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.indexOf(dropOffAndOneWayRental, 0);
              if (index > -1) {
                detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.splice(index, 1);

              }
              //after removing the previous one and here is the mode of disable the one way rental service
              //So we will maeke the return same as PickUp so we need to check if the new DropOff Agency(pickup) does have working hours fees
              //We need to make API request to check
              let req = {
                EndTimeStringSelected: this.viewBooking.endTimeString,
                EndDateStringSelected: this.viewBooking.endDateString,
                EndDate: this.viewBooking.endDate,
                DropOffLocationTypeID: AgencyReturnLocationTypes.Branch,//agencyReturnLocationTypeID
                ToAgencyID: this.viewBooking.agencyID,


              }

              this.bookingService.getWorkingHoursSetting(req).subscribe(res => {
                if (res.isAllow) {

                  this.viewBooking.dropOffLatitude = this.viewBooking.latitude;
                  this.viewBooking.dropOffLongitude = this.viewBooking.longitude;
                  let rentalDeliveryService = this.viewBooking.lstAdditionalServiceReservationCase.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery)[0];
                  if (rentalDeliveryService != null) {
                    let rentalDelevieryFormGroup = this.form.controls[this.formControlPrefix + rentalDeliveryService.additionalServiceID] as FormGroup;
                    rentalDelevieryFormGroup.controls["ReturnLocationName"].setValue(null);
                    rentalDelevieryFormGroup.controls["ReturnLocation"].setValue(null);
                  }
                  if (!res.isWithinWorkingHours) {



                    //Todo: change nonWorkingHoursChargeTypeID to enum
                    let item: LstVehicleReservationCaseNonWorkingHoursChargeModel = {
                      unitPrice: res.charge,
                      name: res.name,
                      isTaxable: res.isTaxable,
                      nonWorkingHoursChargeTypeID: 2,
                      isActive: true,
                      isDropOffAndOneWayRental: true
                    };

                    //Disable the previous one
                    let offDelivery = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.nonWorkingHoursChargeTypeID == 2)[0];

                    if (offDelivery != null) {
                      offDelivery.isActive = false;
                    }

                    detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.push(item);

                  }
                }
                this.viewBookingData.next(detailsModel);
              })
            }


            detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(item => {
              item.isActive = true;
            })
          }


          this.selectedOneWayRental = null;
          this.loadAdditionalServiceData(additionalService, this.vehicleReservationCaseResult.agencyID);
          this.viewBookingData.next(detailsModel);

        }

      }
    }



    this.changeForm(this.form);
  }

  //Add Validations to the form based on the Business Logic
  addValidatorsToForm(additionalService: LstAdditionalServiceReservationCase) {

    //No Required validation for Driver skills
    if (additionalService.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.Drivers) {
      return
    }

    let controlName = 's_' + additionalService.additionalServiceID;
    switch (additionalService.predefinedAdditionalServiceID) {
      case PredefinedAdditionalServiceEnum.CrossingBoarders:
        let controlNameBorders = 's_' + additionalService.additionalServiceID + '_Borders';
        this.form.get(controlNameBorders).setValidators(Validators.required);
        this.form.get(controlNameBorders).updateValueAndValidity();
        break;
      case PredefinedAdditionalServiceEnum.RentalDelivery:

        let rentalDeliveryFirstValidation = 's_' + additionalService.additionalServiceID + "_RentalDeliveryFirstValidation";

        this.form.get(rentalDeliveryFirstValidation).setValidators(Validators.required);
        this.form.get(rentalDeliveryFirstValidation).updateValueAndValidity();

        this.rentalDeliveryErrors = true;

        let formGroup = this.form.controls[controlName] as FormGroup;

        Object.keys(formGroup.controls).forEach(key => {
          if (key.includes('Toggle')) {

            if (formGroup.controls[key].value) {

              this.form.controls[rentalDeliveryFirstValidation].setValue({});

              this.rentalDeliveryErrors = false;
            }

          }

        });
        break
      default:

        this.form.get(controlName).setValidators(Validators.required);
        this.form.get(controlName).updateValueAndValidity();
        break;
    }
  }

  clearValidators(controlName, additionalService) {

    switch (additionalService.predefinedAdditionalServiceID) {
      case PredefinedAdditionalServiceEnum.CrossingBoarders:
        let controlNameBorders = 's_' + additionalService.additionalServiceID + '_Borders';
        this.form.get(controlNameBorders).clearValidators();
        this.form.get(controlNameBorders).updateValueAndValidity();
        this.form.get(controlName).clearValidators();
        this.form.get(controlName).updateValueAndValidity();
        break;
      default:

        this.form.get(controlName).clearValidators();
        this.form.get(controlName).updateValueAndValidity();
        break;
    }
    //this.form.controls[controlName].clearValidators();
  }

  inputChanged() {
    this.changeForm(this.form);
  }
  driverSkillChange(val) {

    this.changeForm(this.form);
  }

  //Handle the crossing border plus button
  //Add a new groupForm into the crossing border dynamic control
  addCrossingBorderToForm(additionalService: LstAdditionalServiceReservationCase, index) {


    let borderObj = this.form.controls['s_' + additionalService.additionalServiceID];
    let borderObjValue: CrossBorderModel = borderObj.value;
    let borderArray = this.form.controls['s_' + additionalService.additionalServiceID + '_Borders'] as FormArray;

    //IF No Border Selected then skip the event
    if (borderObj.value == null || Object.keys(borderObj.value).length == 0) {
      this.showExistBorder = false;
      return;
    }


    //If Item not added before

    if (this.selectedBorders != null && this.selectedBorders.find(o => o.agencyCrossedBorderID == borderObjValue.agencyCrossedBorderID) == null) {



      let borderValue = Number(borderObj.value['charge']);
      if (borderObj.value['isNewInsurence']) {
        //borderValue+=Number(borderObj.value['increase']);
      }

      borderArray.push(new FormGroup({
        BorderName: new FormControl(borderObj.value['borderPortName']),
        BorderValue: new FormControl(borderValue),
        BorderObj: new FormControl(borderObj.value)
      }));
      this.borders = borderArray;
      this.selectedBorders.push(borderObj.value);
      //this.crossBorders.push(this.crossBorders[index]);
      //this.crossBorders.splice(index, 1);
      this.changeForm(this.form);

      this.showExistBorder = false;

    }
    else {
      this.showExistBorder = true;
    }
  }

  //load selected crossing border values
  //Set the values in a local array to prevent duplicate selected values
  loadCrossingBorder(additionalService: LstAdditionalServiceReservationCase, borderObj: CrossBorderModel) {


    let borderArray = this.form.controls['s_' + additionalService.additionalServiceID + '_Borders'] as FormArray;
    //If Item not added before

    if (this.selectedBorders != null && this.selectedBorders.find(o => o.agencyCrossedBorderID == borderObj.agencyCrossedBorderID) == null) {

      borderObj.charge = borderObj.charge;
      borderArray.push(new FormGroup({
        BorderName: new FormControl(borderObj['borderPortName']),
        BorderValue: new FormControl(borderObj['charge']),
        BorderObj: new FormControl(borderObj)
      }));
      this.borders = borderArray;
      this.selectedBorders.push(borderObj);
      this.showExistBorder = false;
      ;
    }
    else {
      this.showExistBorder = true;
    }

    this.changeForm(this.form);


  }

  deleteCrosingBorder(x) {

    let crossborder = this.borders.value[x].BorderObj as CrossBorderModel;
    this.selectedBorders = this.selectedBorders.filter(a => a.agencyCrossedBorderID != crossborder.agencyCrossedBorderID);
    this.borders.removeAt(x);

    this.changeForm(this.form);

  }

  //Open Google-Map-Pin Component in a PopUp(Modal)
  //And let the user select a DropUp||Return location
  //Save the return Obj in the dynamic form
  //And display the formated location in the input

  openMapDialog(type, controlNameInput, controlName, additionalServiceID) {
    const dialogConfig = new MatDialogConfig();

    

    let rentalService = this.form.controls[this.formControlPrefix + additionalServiceID].value;
    let rentalDeliveryService = this.viewBooking.lstAdditionalServiceReservationCase.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery)[0];
    let radius = 0; //rentalDeliveryService.rentalDeliveryServiceScopeValue;
    let circleCoordinate = null;
    let position = null;
    //PickUp Location
    if (type == 1) {
      circleCoordinate = {
        lat: this.viewBooking.latitude,
        lng: this.viewBooking.longitude,
      }

      if (rentalService != null && rentalService.PickUpLocation != null && Object.keys(rentalService.PickUpLocation).length != 0) {
        position = {
          latitude: rentalService.PickUpLocation.latitude,
          longitude: rentalService.PickUpLocation.longitude,
        }
      }

      radius = rentalDeliveryService.rentalDeliveryServiceScopeValuePickup;


    }
    //Return Location
    else if (type == 2) {
      circleCoordinate = {
        lat: this.viewBooking.dropOffLatitude,
        lng: this.viewBooking.dropOffLongitude,
      }
      if (rentalService != null && rentalService.ReturnLocation!= null && Object.keys(rentalService.ReturnLocation).length != 0) {
        position = {
          latitude: rentalService.ReturnLocation.latitude,
          longitude: rentalService.ReturnLocation.longitude,
        }
      }
      radius = rentalDeliveryService.rentalDeliveryServiceScopeValueReturn;
    }


    //dialogConfig.disableClose=true;
    dialogConfig.data = {
      isDraggable: true,
      disableClose: true,
      radius: radius,
      circleCoordinate: circleCoordinate,
      position: position
    }

    const dialogRef = this.dialog.open(GoogleMapPinComponent, dialogConfig);

    dialogRef.componentInstance.locationNameResolved.subscribe(result => {
      if (result != null) {



        let rentalDelivery = this.form.controls[this.formControlPrefix + additionalServiceID] as FormGroup;
        rentalDelivery.controls[controlNameInput].setValue(result.address);
        rentalDelivery.controls[controlName].setValue(result);
      }
    });


  }

  //Handle the checkBox toggle for the DropUp||Return Location
  rentalDeliveryCheckBoxToggle(toggleName, controlNameInput, controlFullObj, additionalService) {


    let controlName = this.formControlPrefix + additionalService.additionalServiceID;
    let formGroup = this.form.controls[controlName] as FormGroup;

    if (formGroup.controls[toggleName].value) {
      formGroup.controls[controlNameInput].enable();
      formGroup.controls[controlNameInput].setValidators(Validators.required);
      formGroup.controls[controlNameInput].updateValueAndValidity();
      let formControl = this.form.get(controlName + '.' + controlNameInput);
    }
    else {

      formGroup.controls[controlNameInput].disable();
      formGroup.controls[controlNameInput].setValue(null);
      formGroup.controls[controlFullObj].setValue(null);
      formGroup.controls[toggleName].setValue(false);
      this.clearValidators(this.formControlPrefix + additionalService.additionalServiceID + "." + controlNameInput, additionalService);
    }

    if (controlNameInput == "PickUpLocationName") {
      this.pickupLocationFlag = !this.pickupLocationFlag;
    }
    else {
      this.returnLocationFlag = !this.returnLocationFlag;
    }
    let rentalDeliveryFirstValidation = 's_' + additionalService.additionalServiceID + "_RentalDeliveryFirstValidation";

    if (!this.pickupLocationFlag || !this.returnLocationFlag) {
      //IF pick up or return checked , clear required validation
      this.form.get(rentalDeliveryFirstValidation).setValue({})
    }
    else {
      //IF pick up and return not checked and the main switch is toggled then throw required validation
      this.form.get(rentalDeliveryFirstValidation).setValue(null)
    }
    this.changeForm(this.form);
  }

  changeForm(model) {
    this.bookingData.next(new FormGroup(model.controls));
  }

  close(): void {
    // this.dialogRef.close();
  }

  // OneWayRentalChanged(model: OneWayRentalModel, additionalService) {

  //   this.viewBooking.dropOffLocationID = model.returnAgencyID;
  //   this.viewBooking.dropOffLocationTypeID = model.agencyReturnLocationTypeID;
  //   if (model != null) {
  //     let req = {
  //       EndTimeStringSelected: this.vehicleReservationCaseResult.endTimeString,
  //       EndDateStringSelected: this.viewBooking.endDateString,
  //       EndDate: this.vehicleReservationCaseResult.endDate,
  //       DropOffLocationTypeID: model.agencyReturnLocationTypeID,
  //       ToAgencyID: model.returnAgencyID,


  //     }
  //     this.bookingService.getWorkingHoursSetting(req).subscribe(res => {



  //       if (res.isAllow) {
  //         this.bookingService.updateDropOffLocation(model);


  //         this.viewBooking.dropOffLatitude = model.latitude;
  //         this.viewBooking.dropOffLongitude = model.longitude;
  //         let rentalDeliveryService = this.viewBooking.lstAdditionalServiceReservationCase.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery)[0];
  //         if (rentalDeliveryService != null) {
  //           let rentalDelevieryFormGroup = this.form.controls[this.formControlPrefix + rentalDeliveryService.additionalServiceID] as FormGroup;
  //           rentalDelevieryFormGroup.controls["ReturnLocationName"].setValue(null);
  //           rentalDelevieryFormGroup.controls["ReturnLocation"].setValue(null);
  //         }
  //         let viewBooking = this.viewBooking;

  //         //Remove any previous nonworking hours
  //         //let preivousNonWorkingHourObj = viewBooking.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.isActive == null || a.isDropOffAndOneWayRental)[0];
  //         let preivousNonWorkingHourObj = viewBooking.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.isActive == null || a.nonWorkingHoursChargeTypeID == 2)[0];
  //         if (preivousNonWorkingHourObj != null) {
  //           let index = viewBooking.lstVehicleReservationCaseNonWorkingHoursChargeModel.indexOf(preivousNonWorkingHourObj, 0);
  //           if (index > -1) {
  //             viewBooking.lstVehicleReservationCaseNonWorkingHoursChargeModel.splice(index, 1);

  //           }
  //         }


  //         if (!res.isWithinWorkingHours) {

  //           //Todo: change nonWorkingHoursChargeTypeID to enum
  //           let item: LstVehicleReservationCaseNonWorkingHoursChargeModel = {
  //             unitPrice: res.charge,
  //             name: res.name,
  //             isTaxable: res.isTaxable,
  //             nonWorkingHoursChargeTypeID: 2,
  //             isActive: true,
  //             isDropOffAndOneWayRental: true
  //           };

  //           //Disable the previous one
  //           let offDelivery = viewBooking.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.nonWorkingHoursChargeTypeID == 2)[0];

  //           if (offDelivery != null) {
  //             offDelivery.isActive = false;
  //           }

  //           viewBooking.lstVehicleReservationCaseNonWorkingHoursChargeModel.push(item);
  //           this.viewBookingData.next(viewBooking);
  //         }
  //         else {
  //           // viewBooking.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(item =>{
  //           //   item.isActive=true;
  //           // })
  //         }
  //         this.viewBookingData.next(viewBooking);

  //         this.changeForm(this.form);
  //       }
  //       else {
  //         let viewBooking = this.viewBooking;
  //         let dropOffAndOneWayRental = viewBooking.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.isDropOffAndOneWayRental)[0];
  //         if (dropOffAndOneWayRental != null) {
  //           let index = viewBooking.lstVehicleReservationCaseNonWorkingHoursChargeModel.indexOf(dropOffAndOneWayRental, 0);
  //           if (index > -1) {
  //             viewBooking.lstVehicleReservationCaseNonWorkingHoursChargeModel.splice(index, 1);

  //           }
  //         }
  //         viewBooking.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(item => {
  //           item.isActive = true;
  //         })
  //         this.viewBookingData.next(viewBooking);

  //         this.form.controls[this.formControlPrefix + additionalService.additionalServiceID].setValue(null);

  //         this.bookingService.getOneWayRentalLocaions(this.viewBooking.agencyID, this.viewBooking.oneWayRentalModel.returnAgencyID, ModeType.Edit, additionalService.isTaxable)
  //           .subscribe(res => {

  //             this.selectedOneWayRental = res.filter(o => o.returnAgencyID == this.viewBooking.oneWayRentalModel.returnAgencyID)[0];
  //             this.oneWayRentalLocations = res;
  //           });



  //         this.translate.get('SorryCantReturnOutsideWorkingHours').subscribe(res => {
  //           this.notifications.warn("<span>" + res + "</span>", null, {
  //             timeOut: 30000,
  //             showProgressBar: false,
  //             pauseOnHover: true,
  //             clickToClose: true,
  //             fade: true,
  //             actions: [{
  //               action: "Allow",
  //             }],
  //             icons: {
  //               error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
  //               warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
  //             }
  //           });
  //         })






  //       }
  //     })

  //   }

  // }

  OneWayRentalChanged(model: OneWayRentalModel, additionalService) {


    this.viewBooking.dropOffLocationID = model.returnAgencyID;
    this.viewBooking.dropOffLocationTypeID = model.agencyReturnLocationTypeID;
    if (model != null) {

      let req = {
        EndTimeStringSelected: this.vehicleReservationCaseResult.endTimeString,
        EndDateStringSelected: this.viewBooking.endDateString,
        EndDate: this.vehicleReservationCaseResult.endDate,
        DropOffLocationTypeID: model.agencyReturnLocationTypeID,
        ToAgencyID: model.returnAgencyID,
      }
      this.bookingService.getWorkingHoursSetting(req).subscribe(res => {



        if (res.isAllow) {
          this.bookingService.updateDropOffLocation(model);


          this.viewBooking.dropOffLatitude = model.latitude;
          this.viewBooking.dropOffLongitude = model.longitude;
          let rentalDeliveryService = this.viewBooking.lstAdditionalServiceReservationCase.filter(a => a.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.RentalDelivery)[0];
          if (rentalDeliveryService != null) {
            let rentalDelevieryFormGroup = this.form.controls[this.formControlPrefix + rentalDeliveryService.additionalServiceID] as FormGroup;
            rentalDelevieryFormGroup.controls["ReturnLocationName"].setValue(null);
            rentalDelevieryFormGroup.controls["ReturnLocation"].setValue(null);
          }
          let detailsModel = this.viewBooking;

          //Remove any previous nonworking hours
          //let preivousNonWorkingHourObj = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.isDropOffAndOneWayRental)[0];
          let preivousNonWorkingHourObj = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.nonWorkingHoursChargeTypeID == 2)[0];
          if (preivousNonWorkingHourObj != null) {
            let index = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.indexOf(preivousNonWorkingHourObj, 0);
            if (index > -1) {
              detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.splice(index, 1);

            }
          }
          //Else there is no previous from changing one way rental , but there is one from search result
          // else if (detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.length > 0 && res.charge == 0) {
          //   detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel[0].isActive = false;
          // }

          if (!res.isWithinWorkingHours) {



            //Todo: change nonWorkingHoursChargeTypeID to enum
            let item: LstVehicleReservationCaseNonWorkingHoursChargeModel = {
              unitPrice: res.charge,
              name: res.name,
              isTaxable: res.isTaxable,
              nonWorkingHoursChargeTypeID: 2,
              isActive: true,
              isDropOffAndOneWayRental: true
            };

            //Disable the previous one
            let offDelivery = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.nonWorkingHoursChargeTypeID == 2)[0];

            if (offDelivery != null) {
              offDelivery.isActive = false;
            }

            detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.push(item);

          }
          else {
            // detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(item => {
            //   item.isActive = true;
            // })
          }
          this.bookingService.updateVehicleReservationCaseDetails(detailsModel);


          this.changeForm(this.form);
        }
        else {

          let detailsModel = this.viewBooking;
          let dropOffAndOneWayRental = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.filter(a => a.isDropOffAndOneWayRental)[0];
          if (dropOffAndOneWayRental != null) {
            let index = detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.indexOf(dropOffAndOneWayRental, 0);
            if (index > -1) {
              detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.splice(index, 1);

            }
          }
          detailsModel.lstVehicleReservationCaseNonWorkingHoursChargeModel.forEach(item => {
            item.isActive = true;
          })
          this.bookingService.updateVehicleReservationCaseDetails(detailsModel);

          this.form.controls[this.formControlPrefix + additionalService.additionalServiceID].setValue(null);
          this.bookingService.getOneWayRentalLocaions(additionalService.agencyID, null, ModeType.Add, null, this.vehicle.classID, this.vehicle.makeID, this.vehicle.modelID, this.vehicle.year, this.vehicle.vehicleID)
            .subscribe(res => {


              this.oneWayRentalLocations = res;


              this.changeForm(this.form);

            });


          this.translate.get('SorryCantReturnOutsideWorkingHours').subscribe(res => {
            this.notifications.warn("<span>" + res + "</span>", null, {
              timeOut: 30000,
              showProgressBar: false,
              pauseOnHover: true,
              clickToClose: true,
              fade: true,
              actions: [{
                action: "Allow",
              }],
              icons: {
                error: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
                warn: '<i class="fas fa-map-marker-alt mr-3 fa-2x"></i>',
              }
            });
          })


        }
      })

    }


  }

  closeModalOnUpdate() {
    //this.dialogRef.close(true);
  }

  //#region Save methods

  submit() {



    this.form.updateValueAndValidity();
    this.submitted = true;
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    let req = this.prepareRequest();

    this.loadingService.updateLoadingState(true);
    this.bookingService.updateConfirmedAdditionalService(req).subscribe(res => {


      if (res != null) {
        if (res["needPayment"]) {
          this.needPayment = true;
          this.requiredPayment = res["requiredPayment"];
          this.objPayment = res["objPayment"];
        }
        else {
          this.closeModalOnUpdate();
          this.bookingService.updateViewBookingState();
          this.onCancel.emit(true);
          this.ngOnDestroy();
        }

      }
      this.loadingService.updateLoadingState(false);
    });
  }

  prepareRequest() {


    //Todo: !!!! add the Not selected additional service to the Modal
    let tmp = this.buildLstAdditionalServiceReservationObject(this.viewBooking.lstAdditionalServiceReservationCase);
    let req: UpdateConfirmedAdditionalServicePram = {

      caseID: this.viewBooking.caseID,

      /*
        vehicleID: this.vehicle.vehicleID,
        classID: this.vehicle.classID,
        makeID: this.vehicle.makeID,
        modelID: this.vehicle.modelID,
        year: this.vehicle.year,


        agencyID:this.vehicleReservationCaseResult.agencyID,
        caseID:this.vehicleReservationCaseResult.caseID,
        endDateString:this.vehicleReservationCaseResult.endDateString,
        startDateString:this.vehicleReservationCaseResult.startDateString,
        endTimeString:this.vehicleReservationCaseResult.endTimeString,
        startTimeString:this.vehicleReservationCaseResult.startTimeString,
        pricingRuleID:this.vehicleReservationCaseResult.pricingRuleID,
        contractTypeID:this.vehicleReservationCaseResult.contractTypeID,
        dropOffLocationID:this.vehicleReservationCaseResult.dropOffLocationID,
        currentLanguage:'en', //Todo: replcae it

        customerModel:customer,
        customerID:customer.customerID,
        customerName:customer.defaultName,
   */
      lstAdditionalServiceReservationCasePramModel: tmp



    }
    return req;
  }

  buildLstAdditionalServiceReservationObject(lstAdditionalServiceReservationCase) {

    let additionalServices = lstAdditionalServiceReservationCase;


    let controls = this.form.controls;
    let res = [];
    additionalServices.forEach(element => {

      let req = {};
      let toggle = controls[this.formControlPrefix + element.additionalServiceID + this.formControlTogglePostfix];
      let value = controls[this.formControlPrefix + element.additionalServiceID].value;
      if (toggle.value && value != null) {
        req['PredefinedAdditionalServiceID'] = element.predefinedAdditionalServiceID;
        req['AdditionalServiceID'] = element.additionalServiceID;
        req['AdditionalServiceTypeID'] = element.additionalServiceTypeID;
        switch (element.predefinedAdditionalServiceID) {
          case PredefinedAdditionalServiceEnum.Drivers:
            /* let driverSkills = value as DriverSkillModel[];
            req[element.predefinedAdditionalServiceID] = driverSkills.map(o => o.driverSkillID); */
            req['Value'] = value;
            break;
          case PredefinedAdditionalServiceEnum.OneWayRentalService:
            /*  let oneWayRental = value as OneWayRentalModel;
             req[element.predefinedAdditionalServiceID] = oneWayRental.returnAgencyID; */
            req['Value'] = value
            break
          case PredefinedAdditionalServiceEnum.AdditionalDrivers:
            req['Value'] = value;
            break;
          case PredefinedAdditionalServiceEnum.RentalDelivery:

            req['Value'] = value


            break
          case PredefinedAdditionalServiceEnum.CrossingBoarders:
            let borderObj = controls[this.formControlPrefix + element.additionalServiceID + '_Borders'];
            let _crossBorders = this.prepareCrossBorders(borderObj);
            req['Value'] = _crossBorders;
            break
          default:
            req['Value'] = value;
            break
        }


        req['Value'] = JSON.stringify(req['Value']);
        res.push(req);
      }

    });

    return res;
  }
  prepareCrossBorders(bordersForm) {
    {
      let _crossBorders: CrossBorderModel[] = [];
      bordersForm.controls.forEach(fg => {

        let formGroup = fg as FormGroup;
        let border = formGroup.controls['BorderObj'].value as CrossBorderModel;
        _crossBorders.push(border);
      });
      return _crossBorders;
    }
  }

  //#endregion

  editDriverInfo() {

  }

  compareDriverIds(id1, id2) {


    return (id1.driverSkillID + "") === (id2.driverSkillID + "");
  }

  checkIFValidQuantity(value, additionalService: LstAdditionalServiceReservationCase) {

    if (additionalService.predefinedAdditionalServiceID == PredefinedAdditionalServiceEnum.AdditionalDrivers) {
      this.changeForm(this.form);
      return;
    }

    if (value > additionalService.maxQuantityAllowed) {
      this.form.controls[this.formControlPrefix + additionalService.additionalServiceID].setValue(additionalService.maxQuantityAllowed);
    }

    if (value <= 0) {
      this.form.controls[this.formControlPrefix + additionalService.additionalServiceID].setValue(1);
    }

    this.changeForm(this.form);
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  changeViewType() {
    this.needPayment = false;
  }


  cancelClicked() {
    this.onCancel.emit(true);
    this.ngOnDestroy();
    // this.router.navigate(['/view-booking', caseID]);
  }

  panelOpenState = false;

  //This is for Prevent user from copy paste on input fileds

  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('keydown', ['$event'])
  public onKeydownHandler(e: KeyboardEvent): void {
    if (e.keyCode === 13) {
      alert("enter")
    }
  }

}
